import React, { useState, useEffect } from 'react';
import { Button, Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import InnerLoader from '../../../Components/Common/InnerLoader';
import CreateAnalyticsChartForm from './CreateAnalyticsChartForm';
import { getAllFields } from '../../../actions/promotion/fields';
import { useDispatch, useSelector } from 'react-redux';
const CreateAnalyticsChart = ({
  pageId = null,
  submitHandler,
  chart = null,
}) => {
  const dispatch = useDispatch();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [open, setOpen] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getFields();
  }, []);

  const submitHandlerFinal = () => {
    setIsOpenModal(false);
    submitHandler();
  };

  const getFields = async () => {
    try {
      const { data } = await getAllFields(
        {
          pageOffset: Math.max(0),
          pageSize: 2000,
        },
        dispatch
      );
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="d-flex flex-row float-end ">
        {chart ? (
          <Button
            color="secondary"
            size="sm"
            onClick={() => {
              console.log('Open config modal');
              setIsOpenModal(true);
            }}
            className="pt-1 pb-1"
            title="Edit Chart"
          >
            <i className="bx bx-edit" />
          </Button>
        ) : (
          <Button
            color="primary"
            size="sm"
            onClick={() => {
              console.log('Open config modal');
              setIsOpenModal(true);
            }}
            className="pt-1 pb-1"
          >
            Create Chart
          </Button>
        )}
      </div>

      <Offcanvas
        isOpen={isOpenModal}
        toggle={() => {
          setIsOpenModal(!isOpenModal);
        }}
        id="offcanvasRight"
        direction="end"
        style={{ width: '90vw' }}
      >
        <OffcanvasHeader
          toggle={() => {
            setIsOpenModal(!isOpenModal);
          }}
          id="offcanvasRightLabel"
          className="align-items-start border-bottom"
        >
          Chart Config
        </OffcanvasHeader>
        <OffcanvasBody>
          <CreateAnalyticsChartForm
            closeHandler={() => setIsOpenModal(false)}
            submitHandler={submitHandlerFinal}
            pageId={pageId}
            chart={chart}
          />
          {isLoading ? <InnerLoader /> : null}
        </OffcanvasBody>
      </Offcanvas>
    </>
  );
};

export default CreateAnalyticsChart;
